// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.teacher-dashboard h1 {
  margin-bottom: 2rem;
  color: #2c3e50;
}

.dashboard-filters {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.search-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #3498db;
}

.group-filter {
  min-width: 200px;
  padding: 0.75rem 1rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 1rem;
  background: white;
  cursor: pointer;
  transition: border-color 0.2s;
}

.group-filter:focus {
  outline: none;
  border-color: #3498db;
}

.dashboard-table-container {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  overflow-x: auto;
  margin-bottom: 2rem;
}

.dashboard-table {
  width: 100%;
  min-width: 800px;
  border-collapse: collapse;
}

.dashboard-table th,
.dashboard-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.dashboard-table th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #2c3e50;
  position: sticky;
  top: 0;
}

.dashboard-table tbody tr:hover {
  background-color: #f8f9fa;
}

.student-link {
  color: #3498db;
  text-decoration: none;
  font-weight: 500;
}

.student-link:hover {
  text-decoration: underline;
}

.attempts-info {
  font-size: 0.75rem;
  color: #7f8c8d;
  margin-top: 0.25rem;
}

.dashboard-legend {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.dashboard-legend h3 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.legend-items {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 0.5rem;
}

.legend-items > div {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.loading {
  text-align: center;
  padding: 3rem;
  font-size: 1.125rem;
  color: #7f8c8d;
}
`, "",{"version":3,"sources":["webpack://./src/pages/teacher/TeacherDashboard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,MAAM;AACR;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".teacher-dashboard h1 {\r\n  margin-bottom: 2rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.dashboard-filters {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.search-input {\r\n  flex: 1;\r\n  padding: 0.75rem 1rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n}\r\n\r\n.group-filter {\r\n  min-width: 200px;\r\n  padding: 0.75rem 1rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  background: white;\r\n  cursor: pointer;\r\n  transition: border-color 0.2s;\r\n}\r\n\r\n.group-filter:focus {\r\n  outline: none;\r\n  border-color: #3498db;\r\n}\r\n\r\n.dashboard-table-container {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n  overflow-x: auto;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.dashboard-table {\r\n  width: 100%;\r\n  min-width: 800px;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.dashboard-table th,\r\n.dashboard-table td {\r\n  padding: 0.75rem;\r\n  text-align: left;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.dashboard-table th {\r\n  background-color: #f8f9fa;\r\n  font-weight: 600;\r\n  color: #2c3e50;\r\n  position: sticky;\r\n  top: 0;\r\n}\r\n\r\n.dashboard-table tbody tr:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.student-link {\r\n  color: #3498db;\r\n  text-decoration: none;\r\n  font-weight: 500;\r\n}\r\n\r\n.student-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.attempts-info {\r\n  font-size: 0.75rem;\r\n  color: #7f8c8d;\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.dashboard-legend {\r\n  background: white;\r\n  border-radius: 8px;\r\n  padding: 1.5rem;\r\n  box-shadow: 0 2px 4px rgba(0,0,0,0.1);\r\n}\r\n\r\n.dashboard-legend h3 {\r\n  margin-bottom: 1rem;\r\n  color: #2c3e50;\r\n}\r\n\r\n.legend-items {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n  gap: 0.5rem;\r\n}\r\n\r\n.legend-items > div {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.loading {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  font-size: 1.125rem;\r\n  color: #7f8c8d;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
